import { dataHooks } from '../../../../libs/dataHooks';

export const megaMenuDropdownSectionDataHooks = dataHooks<{
  headingItemLink: {};
  itemLink: { id: string };
}>('mega-menu-dropdown-section');
